import type { Student } from '@/types/student';
import type { StudentSchedulingDetails } from '../api/getStudentsSchedulingDetails';
import { hasStudentRemainingSessions } from './hasStudentRemainingSessions';

export const hasActiveEnrollment = (studentSchedulingDetails: StudentSchedulingDetails | undefined, timeZone: string): boolean =>
  !!studentSchedulingDetails && hasStudentRemainingSessions(studentSchedulingDetails, timeZone);

const compareByName = (a: Student, b: Student): number =>
  (a.firstName ?? '').localeCompare(b.firstName ?? '', undefined, { sensitivity: 'base' }) ||
  (a.lastName ?? '').localeCompare(b.lastName ?? '', undefined, { sensitivity: 'base' });

const activeEnrollmentsFirst = (a: boolean, b: boolean): number => Number(b) - Number(a);

export const sortStudentsByActiveEnrollmentThenName = (
  students: Student[],
  studentsSchedulingDetails: StudentSchedulingDetails[] = [],
  timeZone: string,
): Student[] => {
  const detailsByStudentId = new Map(studentsSchedulingDetails.map((details) => [details.id, details]));
  const isActive = (student: Student) => hasActiveEnrollment(detailsByStudentId.get(student.id), timeZone);

  return [...students].sort((a, b) => activeEnrollmentsFirst(isActive(a), isActive(b)) || compareByName(a, b));
};
